import { type App } from '~/app';
import { isMobile } from '@root/src/framework/scripts/helpers/browser/media-query';

export default (app: App) => {
	app.logger.debug('[Stockland FE] Initialise Get In Touch Button Component');

	const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

	app.afterMount
		.then(() => {
			mountGetInTouchButton(listeners);
		})
		.catch((error: Error) => {
			throw new Error('[Stockland FE] Unable to register Get In Touch Button Component', error);
		});

	return function destroyGetInTouchButton() {
		unMountGetInTouchButton(listeners);

		app.logger.debug('[DXA] GetInTouch Button Component destroyed');
	};
};

function mountGetInTouchButton(
	listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
	root: HTMLElement | null = null
) {
	let rootNode: Document | HTMLElement = document;
	if (root) rootNode = root;

	const getInTouchButton: HTMLElement | null = rootNode?.querySelector('.get-in-touch-button');
	const getInTouchButtonMobile: HTMLElement | null = rootNode?.querySelector('.get-in-touch-button-mobile');
	if (getInTouchButton) {
		const placeGetInTouchButton = () => {
			let previousScrollPos = window.scrollY;

			window.addEventListener('scroll', () => {
				if (isMobile(1024)) {
					getInTouchButton.style.position = '';
					getInTouchButton.style.bottom = '';
					getInTouchButton.style.right = '';
				} else {
					const currentScrollPos = window.scrollY;
					if (previousScrollPos > currentScrollPos) {
						getInTouchButton.style.position = '';
						getInTouchButton.style.bottom = '';
						getInTouchButton.style.right = '';
					} else {
						getInTouchButton.style.position = 'fixed';
						getInTouchButton.style.bottom = '60px';
						getInTouchButton.style.right = '64px';
					}
					previousScrollPos = currentScrollPos;
				}
			});
		};
		placeGetInTouchButton();
	}
	getInTouchButton?.addEventListener('click', () => {
		const contactSection = document.getElementById('contact-section');
		const ribbonBar = document.querySelector<HTMLElement>('.ribbon-bar');
		const ribbonBarHeight = ribbonBar ? ribbonBar.clientHeight : 0;

		if (!contactSection) return;
		const scrollToPos = contactSection?.getBoundingClientRect().y + window.scrollY - ribbonBarHeight;
		window.scrollTo({ top: scrollToPos, behavior: 'smooth' });
	});
	getInTouchButtonMobile?.addEventListener('click', () => {
		const contactSection = document.getElementById('contact-section');
		const navigation = document.querySelector<HTMLElement>('.hub-navigation-bar');
		const navigationHeight = navigation ? navigation.clientHeight : 0;

		if (!contactSection) return;
		const scrollToPos = contactSection?.getBoundingClientRect().y + window.scrollY - navigationHeight;
		window.scrollTo({ top: scrollToPos, behavior: 'smooth' });
	});
}

export function unMountGetInTouchButton(
	listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
	for (const [element, event, listener] of listeners) {
		element.removeEventListener(event, listener);
	}
}
